<template>
  <ul
    :id="id + '_social_links'"
    class="social-links">
    <li>
      <a
        v-if="facebookLink"
        id="social-link-facebook"
        :href="facebookLink"
        target="_blank">
        <span class="no-text">Visit Us on Facebook</span>
        <span class="sr-only">Opens in a new tab</span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/24/logo-facebook.svg?inline"
          width="24"
          height="24"></svgicon>
      </a>
    </li>
    <li>
      <a
        v-if="twitterLink"
        id="social-link-twitter"
        :href="twitterLink"
        target="_blank">
        <span class="no-text">Visit Us on X</span>
        <span class="sr-only">Opens in a new tab</span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/24/logo-twitter.svg?inline"
          width="24"
          height="24">
        </svgicon>
      </a>
    </li>
    <li>
      <a
        v-if="linkedinLink"
        id="social-link-linkedin"
        :href="linkedinLink"
        target="_blank">
        <span class="no-text">Visit Us on LinkedIn</span>
        <span class="sr-only">Opens in a new tab</span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/24/logo-linkedin.svg?inline"
          width="24"
          height="24"></svgicon>
      </a>
    </li>
    <li>
      <a
        v-if="youtubeLink"
        id="social-link-youtube"
        :href="youtubeLink"
        target="_blank">
        <span class="no-text">Visit Us on YouTube</span>
        <span class="sr-only">Opens in a new tab</span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/24/logo-youtube.svg?inline"
          width="24"
          height="24"></svgicon>
      </a>
    </li>
    <li>
      <a
        v-if="instagramLink"
        id="social-link-instagram"
        :href="instagramLink"
        target="_blank">
        <span class="no-text">Visit Us on Instagram</span>
        <span class="sr-only">Opens in a new tab</span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/24/logo-instagram.svg?inline"
          width="24"
          height="24"></svgicon>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialLinksComponent',
  props: {
    id: String,
    facebookLink: String,
    twitterLink: String,
    linkedinLink: String,
    youtubeLink: String,
    instagramLink: String
  }
}
</script>
